import { useEffect, useRef, useState, type ReactNode } from "react";

/** Native modal semantics provide focus containment, Escape and focus restoration. */
export function ConfirmAction({ title, children, action, phrase, disabled = false, onCancel, onConfirm }: {
  title: string; children: ReactNode; action: string; phrase?: string; disabled?: boolean;
  onCancel: () => void; onConfirm: () => Promise<void>;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const cancel = useRef<HTMLButtonElement>(null);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const opener = document.activeElement as HTMLElement | null;
    const modal = dialog.current;
    modal?.showModal();
    cancel.current?.focus();
    return () => { modal?.close(); if (opener?.isConnected) opener.focus(); };
  }, []);
  return <dialog ref={dialog} className="confirm-dialog" aria-labelledby="confirm-title" aria-describedby="confirm-description"
    onCancel={event => { event.preventDefault(); if (!busy) onCancel(); }}>
    <form onSubmit={async event => {
      event.preventDefault();
      if (busy || disabled || (phrase && typed !== phrase)) return;
      setBusy(true);
      try { await onConfirm(); } finally { setBusy(false); }
    }}>
      <h2 id="confirm-title">{title}</h2>
      <div id="confirm-description">{children}</div>
      {phrase && <label className="confirmation-phrase">Type <strong>{phrase}</strong> to confirm
        <input name="confirmation" value={typed} onChange={event => setTyped(event.target.value)} autoComplete="off" spellCheck={false} disabled={busy} />
      </label>}
      <div className="dialog-actions">
        <button ref={cancel} type="button" className="secondary-button" disabled={busy} onClick={onCancel}>Cancel</button>
        <button type="submit" className="danger-button confirm-danger" disabled={busy || disabled || Boolean(phrase && typed !== phrase)}>{busy ? "Working…" : action}</button>
      </div>
    </form>
  </dialog>;
}
